import Vue from 'vue'
import Vuex from 'vuex'

import ChatControl from './modules/chatControl'
import RelevantControl from './modules/relevantControl'
import SendControl from './modules/sendControl'

Vue.use(Vuex)

const chatControl = new ChatControl()
const relevantControl = new RelevantControl()
const sendControl = new SendControl(chatControl)

const state = {
  chatControl,
  relevantControl,
  sendControl
}

console.log(`Versions 3.3.2`)

export default new Vuex.Store({
  state
})




// WEBPACK FOOTER //
// ./src/controller/index.js